export default __webpack_public_path__ + "static/media/AsstCatalog.f804aa5c.pdf";